import React from "react";
import background from '../images/ApplyBackground.png'
import Navbar from "./navbar";
import Sidebar from "./sidebar";
import backgroundSm from '../images/BackgroundSm.png'

function SubpageTitle(props) {
    return(
        <div>
            <div className="md:block hidden"><Navbar /></div>
            <div className="md:hidden block"><Sidebar /></div>
            <div className="relative w-full md:mt-24">
                    <img className="hidden md:block w-full object-cover" src={background} alt="background"/>
                    <img className="md:hidden block" src={backgroundSm} alt="background"/>
                    <div id="title-block" className="text-white absolute inset-0 flex flex-col items-center justify-center mb-20">
                        <h1 id="title" className="md:text-6xl text-2xl font-semibold py-5">{props.title}</h1>
                    </div>
                </div>
            <p className="w-full text-center pt-10 md:px-0 px-2">{props.subtitle}</p>
        </div>
    )
}

export default SubpageTitle
